import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownRendererProps {
    content: string;
}

export default function MarkdownRenderer({ content }: MarkdownRendererProps) {
    return (
        <div className="mx-auto max-w-3xl py-8 text-gray-200">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h1: (props) => (
                        <h1 className="text-4xl font-bold mb-6 text-white" {...props} />
                    ),
                    h2: (props) => (
                        <h2 className="text-3xl font-semibold mt-8 mb-4 text-white" {...props} />
                    ),
                    h3: (props) => (
                        <h3 className="text-2xl font-semibold mt-6 mb-3 text-white" {...props} />
                    ),
                    p: (props) => (
                        <p className="mb-4 leading-relaxed text-gray-300" {...props} />
                    ),
                    ul: (props) => (
                        <ul className="list-disc ml-6 mb-4 space-y-2" {...props} />
                    ),
                    ol: (props) => (
                        <ol className="list-decimal ml-6 mb-4 space-y-2" {...props} />
                    ),
                    li: (props) => (
                        <li className="text-gray-300" {...props} />
                    ),
                    a: (props) => (
                        <a
                            className="text-blue-400 hover:text-blue-300 underline transition"
                            {...props}
                        />
                    ),
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
}
